export async function waitForSelector(selector, timeout = 30000) {
  return new Promise((resolve, reject) => {
    const intervalTime = 100; // 每隔 100 毫秒检查一次
    let elapsedTime = 0;

    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        resolve(element);
      } else if (elapsedTime >= timeout) {
        clearInterval(interval);
        reject(new Error(`Timeout: Element with selector "${selector}" not found after ${timeout}ms`));
      }
      elapsedTime += intervalTime;
    }, intervalTime);
  });
}

export const clearDom = (selector) => {
  const elems = document.querySelectorAll(selector);
  if (elems.length === 0) {
    return;
  }
  // 依次删除elems
  elems.forEach((elem) => {
    elem.remove();
  });
};

